<template>
	<v-container>
		<h1>Llamadas</h1>
		<span v-if="folio == 0">
			<v-row>
				<v-col cols="12">
					<LlamadasSeguimiento @llamada-seleccionada="llamadaSeguimiento"/>
				</v-col>
			</v-row>
		</span>
		<span v-if="folio != 0">
			<v-row>
				<v-col cols="12">
					<DetalleSeguimiento @cancela-detalle="cancelaDetalle" :datosSeguimiento="datosSeguimiento" />
				</v-col>
			</v-row>
		</span>
	</v-container>
</template>

<script>
import LlamadasSeguimiento from '@/components/LlamadasSeguimiento'
import DetalleSeguimiento from '@/components/DetalleSeguimiento'
export default{
	name: 'Llamadas',
	components: { 
		LlamadasSeguimiento,
		DetalleSeguimiento,
	},
	data() {
		return {
			folio: 0,
			datosSeguimiento: {},
		}
	},
	mounted: function (){
		if(!this.$session.exists()){
			this.$router.push('login')
		} else {
			this.nombreUsuario = this.$session.get('nombre')
			this.esAdmin = this.$session.get('esAdmin')
			if(!this.esAdmin){
				this.$router.push('/')
			}
		}
	},
	methods: {
		llamadaSeguimiento(event) {
			console.log("Evento seleccionado", event)
			this.folio = event.folio
			this.datosSeguimiento = event
		},
		cancelaDetalle(event){
			console.log("Evento: ", event)
			this.folio = event
		}
	},
}
</script>
